//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters } from 'vuex';
import JobDetails from './_components/JobDetails';
import LineDialog from '~/components/Dialog/LineDialog';
const axios = require('axios');

export default {
  name: 'JobsContent',
  layout: 'nothing',
  components: { JobDetails, LineDialog },
  data() {
    return {
      applyShow: false,
      jobDetail: {},
    };
  },
  async asyncData({ route }) {
    let data = {},
      ogTitle = '',
      ogDescription = '';

    //SEO
    const apiURL =
      process.env.deployEnv === 'PROD'
        ? `https://step1ne.com/apis/job-position/${route.query.id}`
        : `https://dev.step1ne.com/apis/job-position/${route.query.id}`;

    try {
      data = await axios.get(apiURL);
    } catch (e) {
      console.log('_id asyncData apiURL not found');
    }

    ogTitle = `${data.data.data.title} - STEP1NE 職缺分享`;
    ogDescription = `探索[${data.data.data.title}]的詳細資訊，這是一個STEP1NE精選的職位機會。了解職位要求、責任和申請流程，並把握機會加入我們的團隊。`;

    return { ogTitle, ogDescription };
  },
  head() {
    return {
      title: this.ogTitle,
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: this.ogTitle,
        },
        {
          hid: 'description',
          name: 'description',
          content: this.ogDescription,
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: this.ogDescription,
        },
      ],
    };
  },
  computed: {
    ...mapGetters('jobs', ['currentJobId']),
    ...mapGetters('user', ['token', 'userName', 'userCategory']),
    liffUrl() {
      const code = this.$route.query.code;
      return `${process.env.LINE_LIFF_URL}?action=invite&code=${code}`;
    },
  },
  methods: {
    ...mapActions('jobs', ['setCurrentJobId', 'setCurrentCompanyId']),
    getJobDetail() {
      this.$api('getJob', { id: this.currentJobId }).then(data => {
        this.jobDetail = data;
      });
    },
    addShareJob(id, code) {
      if (!code) return;
      const payload = {
        jobPositionId: id,
        referCode: code,
      };
      this.$api('accessShareJob', payload);
    },
    openApply() {
      this.applyShow = true;
    },
  },
  mounted() {
    if (process.client) {
      const query = this.$route.query;
      const id = query.id || 0;
      this.setCurrentJobId(id);
      this.getJobDetail();
    }
    this.$nextTick(() => {
      if (process.browser) {
        if (typeof window !== 'undefined') {
          setTimeout(() => {
            if (typeof window.FB !== 'undefined') {
              let fb = document.querySelector('#fb-root');
              if (fb) {
                fb.style.display = 'none';
              }
            }
          }, 1000);
        }
      }
    });
  },
};
